import { Component, OnInit, Input } from '@angular/core';
import { BinsService } from './bins.service';
import { Severity, Answer, Status, ObjectNames } from '../../constants/constants';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { FormGroup, FormArray, FormBuilder, Validators, NgForm } from '@angular/forms';
import { LocationService } from '../location.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import data from '../../staticJSON/binSection.json';

@Component({
  selector: 'app-bins',
  templateUrl: './bins.component.html',
  styleUrls: ['./bins.component.scss']
})
export class BinsComponent implements OnInit {

  @Input() groups = [];
  binForm: FormGroup;
  allBins = [];
  numberList = [];
  answertypeConstants = Answer;
  statusConstants = Status;
  displayBinAvailability: boolean = false;
  displayBinNumberList: boolean = false;
  viewMode: boolean = false;
  headerCheck: boolean = false;
  associatedProducts: string;
  displayAddEditBinDetail: boolean = false;
  binDetailHeader: string;
  allLocations = [];
  separators = ObjectNames.locationConstants.separators;
  setupWizard = ObjectNames.locationConstants.wizard;
  binTypes = [];
  selectedMode: any = {};
  filteredBinGroup;
  binValue;
  binTypeConstants = ObjectNames.locationConstants.BinTypeOption;
  isAddBin: boolean = true;
  invalidData: boolean=false;
  addValidation: boolean=false;
  errorMsg: string='';

  constructor(private binService: BinsService, private confirmationService: ConfirmationService,
    private messageService: MessageService, private titlecasePipe: TitleCasePipe, private fb: FormBuilder,
    private locationService: LocationService, private app: AppMainComponent, private addYearPipe: AddYearPipe) { }

  ngOnInit(): void {
    this.locationService.getBin().subscribe(bin => {
      if (bin) {
        this.showAddBinDetails();
      }
    })
    this.binForm = this.fb.group({
      id: [0],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [0],
      updatedBy: [0],
      createdDate: [''],
      updatedDate: [''],
      organizationId: [0],
      warehouseId: [0],
      name: [''],
      description: [''],
      seperator: ['-'],
      statusId: [Status.ACTIVE],
      typeId: [0],
      isValid: [true],
      validFromDate: [''],
      validToDate: [''],
      binLevel: [''],
      warehouseBin: [''],
      prefix: [''],
      number: [''],
      count: [''],
      capacity: [0]
    });
    this.loadBins();
    this.loadLocations();
    this.getBinType();
  }

  loadLocations() {
    this.locationService.getLocationList().subscribe((locations) => {
      this.allLocations = locations;
    })
  }

  loadBins() {
    this.binService.getBinsList().subscribe((bins) => {
      this.allBins = bins;
    })
  }

  getBinType() {
    this.filteredBinGroup = this.groups.filter(group => group.name == ObjectNames.locationConstants.BinTypeName)[0];
    this.binService.getAllGroupTypes(this.filteredBinGroup.id).subscribe((types) => {
      this.binTypes = types;
      this.selectedMode = this.binTypes[0];
    })
  }

  showAddBinDetails() {
    this.binDetailHeader = ObjectNames.locationConstants.AddBinTitle;
    this.isAddBin=true;
    this.addValidation=false;
    this.displayAddEditBinDetail = true;
    this.invalidData=false;
    this.setupWizard = JSON.parse(JSON.stringify(ObjectNames.locationConstants.wizard));
    this.selectedMode = this.binTypes[0];
    this.binForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      warehouseId: [0, [Validators.required]],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      seperator: [this.separators[0]],
      statusId: [Status.ACTIVE],
      typeId: [0],
      isValid: [true],
      validFromDate: [new Date().toISOString],
      validToDate: [this.addYearPipe.transform(new Date())],
      binLevel: [''],
      warehouseBin: [''],
      prefix: ['', [Validators.required]],
      number: ['', [Validators.required]],
      count: ['', Validators.required],
      capacity: [0]
    });

  }

  showViewBinDetails(bin) {
    this.viewMode = true;
    this.numberList = bin.warehouseBin;
    this.displayBinNumberList = true;
  }

  backToBinDetail() {
    this.displayBinNumberList = false;
    this.displayAddEditBinDetail = true;
  }

  selectDeselectAllLists(value) {
    if (value) {
      this.numberList.forEach(element => {
        element.checked = true;
      });
    } else {
      this.numberList.forEach(element => {
        element.checked = false;
      });
    }
  }

  addLevel() {
    // const addLevelObj = data.addLevel;
    // addLevelObj.id = (this.setupWizard.length + 1);
    // this.setupWizard.push(addLevelObj);

    this.setupWizard.push( {
      "id": (this.setupWizard.length + 1),
      "level": "",
      "code": "",
      "description": "",
      "prefix": "",
      "number": 0
    })
  }

  removeLevel(index) {
    this.setupWizard.splice(index, 1);
  }

  deleteSingleBin(index) {
    this.numberList.splice(index, 1);
  }

  cancelBinDialog() {
    this.loadBins();
  }

  checkValidator(value){
    if(this.selectedMode.name == ObjectNames.locationConstants.BinTypeOption[0]){
      if(value.count>0){
        this.addValidation=false;
        return false;
      }else{
        this.addValidation=true;
        this.errorMsg = 'Bin count must be greater than 0.';
        return true;
      }
    }else{
      if(this.setupWizard[0].number>0 && this.setupWizard[0].prefix!=''){
        this.addValidation=false;
        return false;
      }else{
        this.addValidation=true;
        this.errorMsg = 'Add Number and Prefix for atleast one level.';
        return true;
      }
    }
  }

  nextBinNumberList(value) {
    if(this.checkValidator(value)){
      return;
    }else{
      this.binValue = value;
      this.displayAddEditBinDetail = false;
      //this.displayBinNumberList = true;
      if (this.selectedMode.name == ObjectNames.locationConstants.BinTypeOption[0]) {
        this.numberList = []
        const binId = 1;
        const binNumber = Number(value.number);
        for (let i = 0; i < value.count; i++) {
          let eachManual = {
            id: binId + i,
            name: value.prefix + ' ' + Number(binNumber + i),
          }
          this.numberList.push(eachManual)
        }
      } else if (this.selectedMode.name == ObjectNames.locationConstants.BinTypeOption[1]) {
        this.numberList = [];
        for (let s of this.setupWizard) {
          if (s.number == null) {
            s.number = 0;
          }
        }
        //c.wizards = this.setupWizard;
        let s1 = this.setupWizard[0];
        let s2 = this.setupWizard[1] ? this.setupWizard[1] : null;
        let s3 = this.setupWizard[2] ? this.setupWizard[2] : null;
        let s4 = this.setupWizard[3] ? this.setupWizard[3] : null;

        for (let i = 1; i <= s1.number; i++) {
          let level1 = {
            name: s1.prefix + i,
          }
          if (s2 && s2.number != 0) {
            for (let j = 1; j <= s2.number; j++) {
              let level2 = {
                name: level1.name + value.seperator.name + s2.prefix + j,
              }
              if (s3 && s3.number != 0) {
                for (let k = 1; k <= s3.number; k++) {
                  let level3 = {
                    name: level2.name + value.seperator.name + s3.prefix + k,
                  }
                  if (s4 && s4.number != 0) {
                    for (let m = 1; m <= s4.number; m++) {
                      let level4 = {
                        name: level3.name + value.seperator.name + s4.prefix + m,
                      }
                      this.numberList.push(level4);
                    }
                  } else {
                    this.numberList.push(level3);
                  }
                }
              } else {
                this.numberList.push(level2);
              }
            }
          } else {
            this.numberList.push(level1);
          }
        }
      }
      this.save(this.numberList);
    }
  }

  getSection() {
    this.addValidation=false;
    if (this.selectedMode.name == ObjectNames.locationConstants.BinTypeOption[1]) {
      this.binForm.controls['number'].clearValidators();
      this.binForm.get('number').updateValueAndValidity();
      this.binForm.controls['prefix'].clearValidators();
      this.binForm.get('prefix').updateValueAndValidity();
      this.binForm.controls['count'].clearValidators();
      this.binForm.get('count').updateValueAndValidity();
    } else {
      this.binForm.controls['number'].setValidators(Validators.required);
      this.binForm.controls['prefix'].setValidators(Validators.required);
      this.binForm.controls['count'].setValidators(Validators.required);
    }
  }

  save(value) {
    const warehouseBinList = [];
    const binLevel = [];
    value.forEach(element => {
      const req = {
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        warehouseId: this.binValue.warehouseId.id,
        number: '',
        name: element.name,
        capacity: this.binForm.controls['capacity']?.value,
        description: element.name,
        binSectionId: (this.binValue.id ? this.binValue.id : 0),
        isDefault: false,
        typeId: 0,
        categoryId: 0,
        groupId: 0,
        statusId: Status.ACTIVE,
        isValid: true,
        validFromDate: new Date().toISOString(),
        validToDate: this.addYearPipe.transform(new Date()),
      }
      warehouseBinList.push(req);
    });

    if (this.selectedMode.name == ObjectNames.locationConstants.BinTypeOption[1]) {
      this.setupWizard.forEach(element => {
        const req = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          binSectionId: (this.binValue.id ? this.binValue.id : 0),
          level: element.level,
          prefix: element.prefix,
          number: element.number,
          binCounts: this.numberList.length,
          statusId: Status.ACTIVE,
          isValid: true,
          validFromDate: new Date().toISOString(),
          validToDate: this.addYearPipe.transform(new Date()),
        }
        binLevel.push(req);
      });

    } else {
      const req = {
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        binSectionId: (this.binValue.id ? this.binValue.id : 0),
        level: '',
        prefix: this.binValue.prefix,
        number: this.binValue.number,
        binCounts: this.binValue.count,
        statusId: Status.ACTIVE,
        isValid: true,
        validFromDate: new Date().toISOString(),
        validToDate: this.addYearPipe.transform(new Date()),
      }
      binLevel.push(req);
    }

    const finalReq = {
      id: (this.binValue.id ? this.binValue.id : 0),
      createdSource: this.app.userIP,
      updatedSource: this.app.userIP,
      createdBy: this.app.userId,
      updatedBy: this.app.userId,
      createdDate: new Date().toISOString(),
      updatedDate: new Date().toISOString(),
      organizationId: this.app.companyId,
      warehouseId: this.binValue.warehouseId.id,
      name: this.binValue.name,
      description: this.binValue.name,
      seperator: this.binValue.seperator.name,
      statusId: Status.ACTIVE,
      typeId: this.selectedMode.id,
      isValid: true,
      validFromDate: new Date().toISOString(),
      validToDate: this.addYearPipe.transform(new Date()),
      binLevel: binLevel,
      warehouseBin: warehouseBinList,
    }
    if (this.isAddBin) {
        this.binService.addBin(finalReq).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Bins Added successfully...' });
          this.loadBins();
          this.displayBinNumberList = false;
        }).catch(() => {
          this.displayBinNumberList = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
    } else {
        this.binService.updateBin(finalReq).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Location Updated successfully...' });
          this.loadBins();
          this.displayBinNumberList = false;
        }).catch(() => {
          this.displayBinNumberList = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
    }
  }

  showEditBinDetails(bin) {
    this.isAddBin = false;
    this.invalidData=false;
    this.addValidation=false;
   // this.checkBin(bin, ObjectNames.locationConstants.EditAction);
    this.setupWizard = [];
    this.binDetailHeader = ObjectNames.locationConstants.EditBinTitle;
    this.displayAddEditBinDetail = true;
    this.binForm.patchValue(bin);
    this.binForm.controls['capacity'].setValue(bin.warehouseBin.length>0 && bin.warehouseBin[0].capacity);
    const filteredLocation = this.allLocations.filter(location => location.id == bin.warehouse.id)[0];
    this.binForm.controls['warehouseId'].setValue(filteredLocation);
    const filteredSeperator = ObjectNames.locationConstants.separators.filter(seperator => seperator.name == bin.seperator)[0];
    this.binForm.controls['seperator'].setValue(filteredSeperator);
    this.selectedMode = this.binTypes.filter(type => type.id == bin.typeId)[0];
    if (this.selectedMode.name == ObjectNames.locationConstants.BinTypeOption[0]) {
      this.binForm.controls['count'].setValue(bin.binLevel[0].binCounts);
      this.binForm.controls['prefix'].setValue(bin.binLevel[0].prefix);
      this.binForm.controls['number'].setValue(bin.binLevel[0].number);
    }
    this.setupWizard = bin.binLevel;

  }

  checkBin(bin, action) {
    this.binService.checkAssociatedBin(bin.id).subscribe((bins) => {
      if (action == ObjectNames.locationConstants.DeleteAction) {
        if (!bins.item1) {
          this.delete(bin);
        } else {
          this.associatedProducts = bins.item2;
          this.displayBinAvailability = true;
        }
      } else {
        if (!bins.item1) {
          this.showEditBinDetails(bin);
        } else {
          //this.viewMode = true;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Edit bins is not allowed as this bin is associated with products...' });
        }
      }
    })
  }

  delete(bin) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Bin?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.binService.deleteBin(bin.id).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          const index = this.allBins.indexOf(bin);
          this.allBins.splice(index, 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
}
